import * as React from 'react';

import { Range } from 'rc-slider';
import { Typography } from '@material-ui/core';

type Value = [number, number];

interface Props {
  onChange: (range: Value | undefined) => void;
  value?: Value;
}

interface State {
  tempValue: Value | undefined;
}

function mapToExternalValue(data: number[]): Value | undefined {
  if (!data || data.length < 2) {
    return undefined;
  }

  const [min, max] = data;

  if (min === 0 && max === 1) {
    return undefined;
  }

  return [min, max];
}

function mapFromExternallValue(value: Value | undefined): number[] {
  if (!value) {
    return [0, 1];
  }

  return value;
}

export default class NdviRange extends React.Component<Props, State> {
  state = {
    tempValue: undefined
  };

  handleOnChange = async (data: number[]) => {
    const tempValue = mapToExternalValue(data);
    await this.setState({ tempValue });
  };

  handleAfterChange = async () => {
    const { onChange } = this.props;
    const { tempValue } = this.state;
    if (!tempValue) {
      return;
    }

    await this.setState({ tempValue: undefined });
    onChange(tempValue);
  };

  render() {
    const { value } = this.props;
    const data = mapFromExternallValue(value);
    return (
      <>
        <Range
          min={0}
          max={1}
          count={1}
          step={0.01}
          allowCross={false}
          value={data}
          onChange={this.handleOnChange}
          onAfterChange={this.handleAfterChange}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            marginTop: 8
          }}
        >
          <Typography
            style={{
              flex: 1,
              textAlign: 'left'
            }}
          >
            {data[0].toFixed(2)}
          </Typography>
          <Typography
            style={{
              flex: 1,
              textAlign: 'right'
            }}
          >
            {data[1].toFixed(2)}
          </Typography>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NdviRange.tsx